import { useState } from 'react';
import { Cta } from '@/components/Cta';
import GradientTitle from '@/components/SolutionsTemplate/GradientTitle';
import styles from "@/styles/solutionsTemplate/landingElement.module.scss";
import json_retail_en from "@/components/jsons/solutionsTemplate/retailEn.json";

interface SolutionTemplateProps {
    type: string;
    jsonData: any;
}

export default function LandingElement({
    type,
    jsonData,
}: SolutionTemplateProps) {

    function determineLandingElementBackgroundColour() {

        if (type === "retail")
            return ("rgba(247, 162, 133, 0.1)");

        else if (type === "transportation")
            return ("rgba(50, 191, 138, 0.2)");

        else if (type === "industries")
            return ("rgba(210, 142, 255, 0.2)");
    }

    function getLightEffectClass() {
        if (type === "retail")
            return "light_effect_card_retail";
        else if (type === "transportation")
            return "light_effect_card_transport";
        else if (type === "industries")
            return "light_effect_card_industry";
        return "light_effect_card";
    }

    return (
        <div className={styles.rootDiv}>
            <div className={styles.landingElement}>

                <div
                    className={`${styles.landingElementInnerDiv} ${getLightEffectClass()}`}
                    style={{
                        backgroundColor: determineLandingElementBackgroundColour(),
                    }}>

                    <div style={{
                        margin: "0 auto"
                    }}>
                        <GradientTitle
                            text={jsonData?.title}
                            fontSize={"clamp(2.5rem, 8vw, 75px)"}
                            fontWeight={"800"} />
                    </div>

                    <div className={styles.subtitleDiv}>
                        {jsonData?.subtitle}
                    </div>

                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        width: "100%",
                        marginTop: "30px",
                        justifyContent: "center",
                        //border: "1px solid red"
                    }}>
                        <Cta className="" size='small'>
                            {jsonData.cta}
                        </Cta>
                    </div>

                    <div style={{
                        fontWeight: "300",
                        fontSize: "clamp(0.85rem, 2vw, 15px)",
                        opacity: "0.75",
                        margin: "0 auto",
                        textAlign: "center",
                        marginTop: "20px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                    }}>
                        {jsonData.microcopy}
                    </div>
                </div>

                <div
                    className={styles.fade}
                    style={{
                        backgroundImage: jsonData?.coverImage,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center"
                    }} />

            </div>
        </div>
    )
}